export enum PaymentDocumentType {
  FullReceipt = 'FULL_RECEIPT',
  Invoice = 'INVOICE',
  InvoiceReceipt = 'INVOICE_RECEIPT',
}
